import BaseService from './base.service'
import { sortTree } from '../utils/functions'


class VideoService extends BaseService{
    async getTreeData(folderId) {
        const url = folderId ? '/api/v1/videos/tree?folderId='+folderId : '/api/v1/videos/tree';
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'same-origin',
        })
        const data = await response.json()
        sortTree(data)
        return data
    }

    async getVideos(folderId) {
        const response = await fetch(
            `/api/v1/videos/tree/folder/files?folderId=${folderId}`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'same-origin',
            }
        )
        const data = await response.json()
        return data.files
    }

    async saveFolder(folder, folderPath) {
        const response = await fetch(`/api/v1/videos/tree/folder`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ folder: folder, folderPath: folderPath }),
            credentials: 'same-origin',
        })

        const folders = await response.json()
        console.log('saveFolder: rsp ', folders)
        return folders[0]
    }

    async deleteVideo(videoId) {
        const response = await fetch(`/api/v1/videos/file/delete`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ fileId: videoId }),
            credentials: 'same-origin',
        })

        const rsp = await response.json()

        return rsp
    }

    async moveFolder(srcFolderId, targetFolderId) {
        const response = await fetch(`/api/v1/videos/folder/paste`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                pasteFolderId: targetFolderId,
                cutFolderId: srcFolderId,
            }),
            credentials: 'same-origin',
        })

        const rsp = await response.json()

        return rsp
    }

    async moveFiles(srcFileIds, targetFolderId) {
        const response = await fetch(`/api/v1/videos/file/paste`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                pasteFolderId: targetFolderId,
                cutFileIds: srcFileIds,
            }),
            credentials: 'same-origin',
        })

        const rsp = await response.json()

        return rsp
    }

    async deleteFolder(folderId) {
        const response = await fetch(`/api/v1/videos/folder/delete`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                folderId: folderId
            }),
            credentials: 'same-origin',
        })

        const rsp = await response.json()

        return rsp
    }

    async generateFileSharedLink(documentId) {
        const response = await fetch(`/api/v1/videos/file/share/generatelink`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ fileId: documentId }),
            credentials: 'same-origin',
        })
        this.handleHttpErrors(response)
        const rsp = await response.json()

        return rsp
    }

    async generateFolderSharedLink(folderId) {
        const response = await fetch(`/api/v1/videos/folder/share/generatelink`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ folderId: folderId }),
            credentials: 'same-origin',
        })

        const rsp = await response.json()

        return rsp
    }

    async saveFolderSecurity(folderId, folderPath, securityDetail) {
        const response = await fetch(`/api/v1/videos/folder/security/save`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                folderId: folderId,
                folderPath: folderPath,
                securityDetail: JSON.stringify(securityDetail),
            }),
            credentials: 'same-origin',
        })

        const rsp = await response.json()

        return rsp
    }

    async saveStyles(folderId, folderPath, iconColor, textStyle, textSize) {
        const body = {
            folderId: folderId,
            folderPath: folderPath,
            stateColor: iconColor,
            boldText: textStyle.includes('bold') ? 'on' : undefined,
            italicText: textStyle.includes('italic') ? 'on' : undefined,
            textSize: textSize,
        }

        const response = await fetch(`/api/v1/videos/folder/properties/save`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
            credentials: 'same-origin',
        })

        const rsp = await response.json()

        return rsp
    }

    async saveFolderComments(folderId, comments) {
        const body = {
            folderId: folderId,
            comments: comments,
        }

        const response = await fetch(`/api/v1/videos/folder/comments`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
            credentials: 'same-origin',
        })

        const rsp = await response.json()

        return rsp
    }

    async saveFileComments(fileId, comments) {
        const body = {
            fileId: fileId,
            comments: comments,
        }

        const response = await fetch(`/api/v1/videos/file/comments`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
            credentials: 'same-origin',
        })

        const rsp = await response.json()

        return rsp
    }
}
const videoService = new VideoService()

export default videoService